module.exports = __webpack_public_path__ + "e637e4477d47d12099158513d06d1e96.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/TWS.jpg
// module id = 764
// module chunks = 0